import { defineFormSchema } from '../../../shared/data/formSchema';
export const assignmentFormSchema = defineFormSchema({
  id: 'deals.assignment.create',
  fields: [
    {
      name: 'title',
      label: 'Titolo',
      required: true,
      primary: true,
      table: { minWidth: 190, order: 0, accessor: (row) => row.title || row.description },
    },
    { name: 'description', label: 'Descrizione', type: 'textarea', required: true },
    { name: 'type', label: 'Tipo task', required: true, table: { hidden: true } },
    { name: 'recipients', label: 'Assegnato a', table: { order: 1 } },
    { name: 'sender', label: 'Richiesto da', readOnly: true, table: { order: 2 } },
    {
      name: 'urgency',
      label: 'Urgenza',
      required: true,
      type: 'select',
      options: [
        { value: 'alta', label: 'Alta' },
        { value: 'media', label: 'Media' },
        { value: 'bassa', label: 'Bassa' },
      ],
      table: { order: 5 },
    },
    { name: 'dueDate', label: 'Scadenza', type: 'date', required: false, table: { order: 4 } },
    { name: 'clientId', label: 'Cliente', table: false },
    { name: 'supplierId', label: 'Fornitore', table: false },
  ],
});
